import { store } from '../index'
import { signOut, enqueueSnackbar } from '../store/actions'

const protocal = process.env.REACT_APP_API_SERVER_PROTOCAL
const serverPath = process.env.REACT_APP_API_SERVER_PATH
const port = process.env.REACT_APP_API_SERVER_PORT
  ? `:${process.env.REACT_APP_API_SERVER_PORT}`
  : ''
const baseUrl = process.env.REACT_APP_API_SERVER_BASE_URL

export const baseAPIPath = `${protocal}://${serverPath}${port}/${baseUrl}`

export const authRequestInterceptors = config => {
  let token = null
  let rawToken = localStorage.getItem('authToken')

  if (!rawToken) {
    rawToken = sessionStorage.getItem('authToken')
  }

  try {
    token = JSON.parse(rawToken)
  } catch (error) {
    token = null
  }

  config.headers = {
    ...config.headers,
    Authorization: `Bearer ${token}`
  }
  return config
}

export const authResponseSuccessInterceptors = response => {
  return response
}

export const authResponseErrorInterceptors = error => {
  switch (error?.response?.status || 'noResponse') {
    case 401:
      if (store.getState().auth.token !== null) {
        store.dispatch(
          enqueueSnackbar({
            message: '401SE',
            options: {
              variant: 'error'
            }
          })
        )
        store.dispatch(signOut())
      }
      break
    case 500:
      if (error?.request?.responseURL.indexOf('dropdown') === -1) {
        store.dispatch(
          enqueueSnackbar({
            message: error?.response?.data?.message || '500',
            options: {
              variant: 'error'
            }
          })
        )
      }
      break
    case 'noResponse':
      // if (!store.getState().alert.notifications.length) {
      //   store.dispatch(
      //     enqueueSnackbar({
      //       message: '500',
      //       options: {
      //         variant: 'error'
      //       }
      //     })
      //   )
      // }
      break
    default:
      break
  }
  return Promise.reject(error)
}
